module.exports = __webpack_public_path__ + "img/rescue.c0f1ee08.gif";